<template xmlns="http://www.w3.org/1999/html">
    <div class="setting-page-content-wrapper features">
        <div class="page-header">
            <div class="title">{{ $t("settings.languageTimeZone") }}</div>
            <div class="subtitle">{{ $t("settings.languageSubtitles") }}</div>
        </div>
        <section>
            <div class="fields">
                <FeatureItem
                    :title="$t('message.languageTitle1')"
                    icon="Language1"
                    v-model="clientLanguage"
                    :description="$t('message.languageDesc1')"
                    type="select"
                    :options="languages.map((x) => ({ id: x.code, label: x.name }))"
                    :default-select-option-placeholder="$t('message.selectALanguage')"
                />
                <FeatureItem
                    :title="$t('message.languageTitle2')"
                    icon="Language2"
                    v-model="customerClientLanguage"
                    :description="$t('message.languageDesc2')"
                    type="select"
                    :options="languages.map((x) => ({ id: x.code, label: x.name }))"
                    :default-select-option-placeholder="$t('message.selectALanguage')"
                />
                <FeatureItem
                    :title="$t('message.languageTitle3')"
                    icon="TimeZoneIcon"
                    v-model="defaultTimzezone"
                    :description="$t('message.languageDesc3')"
                    type="select"
                    :options="timezones.map((x) => ({ id: x, label: x }))"
                    :default-select-option-placeholder="$t('message.selectALanguage')"
                />
                <FeatureItem
                    v-model="customerClientLanguageDetect"
                    :description="$t('message.languageDesc4')"
                    :title="$t('message.languageTitle4')"
                    icon="Language3"
                />
                <!--                <FeatureItem-->
                <!--                    v-model="visitorPreferredLang"-->
                <!--                    :description="$t('message.vtipyVisitorPreferredLang')"-->
                <!--                    :title="$t('message.visitorPreferredLang')"-->
                <!--                    icon="Language4"-->
                <!--                />-->
                <FeatureItem
                    v-model="languageShow"
                    :description="$t('message.languageDesc5')"
                    :title="$t('message.languageTitle5')"
                    icon="Language4"
                />
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import log2 from "../../../../../utils/log2";
import FeatureItem from "../../components/FeatureItem.vue";
import { getNavigatorTimezone } from "../../../../../utils/language";
import moment from "moment-timezone";

const log = log2("Settings/Language");

const momentTimezoneList = moment.tz.names();
const defaultTZ =
    momentTimezoneList.find(
        (x) => x.trim().toLowerCase().indexOf(getNavigatorTimezone().timeZone.trim().toLowerCase()) !== -1
    ) || "UTC";
export default {
    name: "Language",
    components: {
        FeatureItem,
    },
    props: {
        updateSettings: {
            type: Function,
            required: true,
        },
    },
    data: () => ({
        timezones: momentTimezoneList,
    }),
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            languages: (state) => state.language.languages,
            language: (state) => state.language.language,
            settingInitialized: (state) => state.setting.initialized,
            visitorScreenUrl: (state) => {
                const isProduction = process.env.ENVIRONMENT === "production";
                const isStage = process.env.ENVIRONMENT === "stage";
                let siteAlias = (state.site.site.customerClientAddress || "").replace(".visitor.supsis.live", "");
                const protocol = isProduction || isStage ? "https" : "http";
                if (siteAlias === "visitor.supsis.live") siteAlias = "demo-site.supsis.live?customer=supsis";
                else siteAlias = "demo-site.supsis.live?customer=" + siteAlias;
                const hostname = isProduction
                    ? siteAlias
                    : isStage
                    ? `demo-site.supsis.live?url=${protocol}://${
                          state.site.site.customerClientAddress || "betavisitor.supsis.live"
                      }/static/js/loader.js`
                    : "localsite.supsis.live?customer=local";
                return `${protocol}://${hostname}`;
            },
            systemLanguages: (state) => state.setting.settings.systemLanguages,
        }),
        clientLanguage: {
            get() {
                return this.language.name;
            },
            set(value) {
                if (!!value) {
                    this.setCurrentLanguage(value);
                    console.warn("Dil başarıyla değiştirilidi!");
                    this.setValue("language.clientDefault", value);
                } else {
                    this.$message.error("Please select a language");
                }
            },
        },
        customerClientLanguage: {
            get() {
                return this.settings.language.customerClientDefault;
            },
            set(value) {
                this.setValue("language.customerClientDefault", value);
                if (!!value) {
                    this.setValue("language.customerClientDefault", value);
                } else {
                    this.$message.error("Please select a language");
                }
            },
        },
        customerClientLanguageDetect: {
            get() {
                return this.settings.language.customerClientLanguageDetect == 1;
            },
            set(value) {
                this.setValue("language.customerClientLanguageDetect", value);
            },
        },
        visitorPreferredLang: {
            get() {
                return this.settings.visitorPreferredLang;
            },
            set(value) {
                this.setValue("visitorPreferredLang", value);
            },
        },
        defaultTimzezone: {
            get() {
                return this.settings.language.timezone || defaultTZ;
            },
            set(value) {
                this.setValue("language.timezone", value);
            },
        },
        languageShow: {
            get() {
                return this.settings.languageShow;
            },
            set(value) {
                this.setValue("languageShow", value);
            },
        },
    },
    methods: {
        setValue(key, value) {
            this.updateSettings(key, value);
        },
        ...mapActions({
            setLanguage: "language/setLanguage",
        }),
        setCurrentLanguage(languageCode) {
            log.info("setCurrentLanguage", languageCode);
            this.setLanguage(languageCode);
            this.$i18n.locale = this.language.code;
            if (moment.locale() !== languageCode) moment.locale(languageCode);
            this.isOpenLang = !this.isOpenLang;
        },
    },
};
</script>

<style scoped lang="scss">
.feature {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 10px;
    border: 1px solid var(--color-border-default);
    border-radius: 4px;
    background: var(--color-bg-neutral-default);
    max-width: 900px;

    .left {
        display: flex;
        align-items: center;
        gap: 20px;

        .icon {
            svg {
                width: 40px;
                height: 40px;
                fill: var(--color-bg-primary-default);
            }
        }

        .feature-title {
            font-size: 16px;
            font-weight: 500;
            color: var(--color-text-strong-default);
        }

        .feature-description {
            font-size: 14px;
            font-weight: 400;
            color: var(--color-text-low-default);
        }
    }
}

.errSpan {
    font-size: 8px;
    color: var(--color-bg-critical-default);
}

.right {
    display: flex !important;
    align-items: center !important;

    .ant-switch-checked {
        background-color: var(--color-bg-primary-default);
    }
}

.dark-mode .feature {
    background: #1e1e2d;

    .left {
        .icon {
            svg {
                fill: var(--color-bg-primary-default);
            }
        }

        .feature-title {
            color: #fff;
        }

        .feature-description {
            color: var(--color-text-low-default);
        }
    }
}
</style>
